import * as Yup from "yup";

export const dataModel = {
  email: "",
  password: "",
};

export const validationDataModel = Yup.object().shape({
  email: Yup.string().required("forms.validations.required"),
  password: Yup.string().required("forms.validations.required"),
});
